const firebaseConfig = {
  apiKey: "AIzaSyDOivKN7VZO10TfFdbA2R9OES4fSxjHSB4",
  authDomain: "odev-react.firebaseapp.com",
  projectId: "odev-react",
  storageBucket: "odev-react.appspot.com",
  messagingSenderId: "87962040951",
  appId: "1:87962040951:web:4ef412378d015227972472",
  measurementId: "G-9446FYPMX6"
  };

export default firebaseConfig;